import React, { createContext, useContext, useState } from 'react';

const NavbarVisibilityContext = createContext();

export const NavbarVisibilityProvider = ({ children }) => {
  const [hideNavbar, setHideNavbar] = useState(false);

  return (
    <NavbarVisibilityContext.Provider value={{ hideNavbar, setHideNavbar }}>
      {children}
    </NavbarVisibilityContext.Provider>
  );
};

export const useNavbarVisibility = () => {
  const context = useContext(NavbarVisibilityContext);
  if (!context) {
    throw new Error('useNavbarVisibility must be used within a NavbarVisibilityProvider');
  }
  return context;
};
